<template>
  <Layout>
    <PageHeader :title="'Kampanyalar'" :items="breadcrumbArray"></PageHeader>
    <v-app>
      <div class="row">
        <div class="col-lg-12 pb-5 mb-5">
          <v-tabs icons-and-text mobile-breakpoint="lg" grow>
            <v-tab>
              KAMPANYALI STOKLAR
              <v-icon> mdi-label-percent </v-icon>
            </v-tab>
            <v-tab>
              SEPET KAMPANYALARI
              <v-icon> mdi-basket </v-icon>
            </v-tab>

            <v-tab-item>
              <ResultsStock
              ></ResultsStock>
            </v-tab-item>
            <v-tab-item>
              <ResultsBasket v-if="this.current?.code || this.user.RoleGroupId === '1'"></ResultsBasket>
              <div v-else class="d-flex flex-column justify-content-center align-items-center mt-10 mb-10">
                <span class="fs-4" style="color: red">Lütfen Cari Seçimi Yapın</span>
              </div>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </v-app>
  </Layout>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import ResultsBasket from "@/components/campaign/basket/Results";
import ResultsStock from "@/components/campaign/stocks/Results";
import {mapState} from "vuex";

export default {
  name: "Campaign",
  page: {
    title: "Kampanyalar",
    meta: [{ name: "description", content: "Kampanyalar" }],
  },
  components: {
    Layout,
    PageHeader,
    ResultsBasket,
    ResultsStock
  },
  computed: {
    ...mapState("cart",["current"]),
    ...mapState("auth", ["user"]),
  },
  mounted() {

  },
  data() {
    return {
      erpSettingsProp: {},
      generalSettingsProp: {},
      mailSettingsProp: {},
      breadcrumbArray: [
        {
          text: "Kampanyalar",
          active: true,
        }
      ],
    };
  },
  methods: {

  },
};
</script>